/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateLocationResponse
 */
export interface UpdateLocationResponse {
  /**
   *
   * @type {boolean}
   * @memberof UpdateLocationResponse
   */
  carrierNotified: boolean;
}

/**
 * Check if a given object implements the UpdateLocationResponse interface.
 */
export function instanceOfUpdateLocationResponse(
  value: object,
): value is UpdateLocationResponse {
  if (!("carrierNotified" in value) || value["carrierNotified"] === undefined)
    return false;
  return true;
}

export function UpdateLocationResponseFromJSON(
  json: any,
): UpdateLocationResponse {
  return UpdateLocationResponseFromJSONTyped(json, false);
}

export function UpdateLocationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateLocationResponse {
  if (json == null) {
    return json;
  }
  return {
    carrierNotified: json["carrierNotified"],
  };
}

export function UpdateLocationResponseToJSON(
  json: any,
): UpdateLocationResponse {
  return UpdateLocationResponseToJSONTyped(json, false);
}

export function UpdateLocationResponseToJSONTyped(
  value?: UpdateLocationResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierNotified: value["carrierNotified"],
  };
}
